<script setup>
import Button from "primevue/button";
defineProps({
  label: {
    default: "",
    type: String,
  },
});
const emit = defineEmits(["click"]);
</script>
<script>
export default {
  // eslint-disable-next-line vue/no-reserved-component-names
  name: "Button",
};
</script>
<template>
  <Button :label="label" @click="emit('click')" />
</template>

<style scoped>
.p-button {
  color: #ffffff;
  background: pink;
  font-size: 20px;
}
</style>
